// Updated to use enhanced communication service
import type { SendEmailRequest, SendEmailResponse } from "@/app/(authenticated)/communication/_modules/types/sendEmail.types";
import { communicationService } from "@/app/_module/services/communicationService";
import type { SendEmailRequest as EnhancedSendEmailRequest } from "@/app/_module/services/communicationService";

// Type adapter for backward compatibility
const adaptEmailRequest = (data: SendEmailRequest): EnhancedSendEmailRequest => ({
  to: data.to,
  subject: data.subject,
  body: data.body || data.text || data.html || '',
  useOAuth: data.useOAuth,
  provider: data.provider,
  leadId: data.leadId,
  cc: data.cc,
  bcc: data.bcc,
  attachments: data.attachments,
});

export const sendEmail = async (data: SendEmailRequest): Promise<SendEmailResponse | null> => {
  try {
    const adaptedData = adaptEmailRequest(data);
    const response = await communicationService.sendEmail(adaptedData);
    
    // Adapt response format for backward compatibility
    return {
      statusCode: response.statusCode,
      message: response.message,
      data: {
        emailId: response.data.emailId,
        status: response.data.status,
        to: response.data.to,
        subject: response.data.subject,
        body: response.data.body,
        sentAt: response.data.sentAt,
      },
      timestamp: response.timestamp,
      timeTakenMs: response.timeTakenMs,
      path: response.path,
    };
  } catch (error) {
    // Enhanced service already handles errors and toasts
    return null;
  }
};

